import dayjs from 'dayjs';

export interface IDeviceCommunication {
  id?: number;
  companyId?: number | null;
  companyName?: string | null;
  assetId?: number | null;
  assetLicensePlate?: string | null;
  contractDate?: string | null;
  firstCommunicationDate?: string | null;
  lastCommunicationDate?: string | null;
  daysSinceFirstCommunication?: number | null;
  daysSinceLastCommunication?: number | null;
  iccid?: string | null;
}

export const defaultValue: Readonly<IDeviceCommunication> = {};
